import { Filters } from "@/common/filters.global";

export const MOCK_EVENT_DETAILS: JustificationRequest = {
  customMessage: "this is custom",
  eventDetails: {
    files: [],
    untrustedEntities: [],
    untrustedLabelNames: [],
  },
  application: "OneDrive",
  eventTime: "",
  eventType: "Email",
  risksDetected: [],
  severity: "High",
  targetUserId: "",
  targetUserMail: "",
  untrustedFolders: [],
  untrustedOrganizations: [],
  untrustedPersonalAddresses: [],
  untrustedUserEmails: [],
};

export interface JustificationTableItem {
  id: string;
  date: string;
  asked_at: string;
  severity: "Critical" | "High" | "Medium" | "Low" | "None";
  user: {
    email: string;
    id: string;
  };
  request_by: {
    email: string;
    id: string;
  };
  status: "Opened" | "Completed";
  pending_count: number;
  event_details: JustificationRequest;
  event_type: "Email" | "File uploaded" | "Anonymous link created";
  application: string;
}

const event_types = {
  Email: "Email",
  Generic: "Generic",
  SecureLinkCreated: "Secure Link Created",
  SecureLinkUpdated: "Secure Link Updated",
  AnonymousLinkCreated: "Anonymous Link Created",
  AnonymousLinkUpdated: "Anonymous Link Updated",
  CompanyLinkCreated: "Company Link Created",
  FileUploaded: "File Uploaded",
  FileDownloaded: "File Downloaded",
  FileSyncUploadedFull: "File Sync Uploaded Full",
  SharingSet: "Sharing Set",
};

export const JustificationTableItemHelper = {
  from_justification: (indexed_admins: Record<string, string>) => (
    jus: Justification
  ): JustificationTableItem => {
    return {
      asked_at: jus.creationTime,
      application: jus.request.application,
      // @ts-ignore
      application_name: Filters.serviceName(jus.request.application),
      date: jus.request.eventTime,
      event_details: jus.request,
      event_id: jus.eventId,
      // @ts-ignore
      event_type: event_types[jus.request.eventType] as string,
      id: jus.id,
      pending_count: -1,
      request_by: {
        id: jus.issuerUserId,
        email: jus.issuerEmail || indexed_admins[jus.issuerUserId] || "unknown",
      },
      statement: jus.statement,
      severity: jus.request.severity,
      status: jus.status,
      user: {
        id: jus.request.targetUserId,
        email: jus.request.targetUserMail,
      },
    };
  },
};

export interface JustificationRequest {
  targetUserId: string;
  targetUserMail: string;
  untrustedUserEmails: string[];
  untrustedPersonalAddresses: string[];
  untrustedOrganizations: string[];
  untrustedFolders: string[];
  // Compliance Risk Insight Names
  risksDetected: string[];
  severity: "High" | "Medium" | "Low" | "None";
  eventDetails: {
    files: Array<{ fileName: string; label: string }>;
    untrustedEntities: string[];
    untrustedLabelNames: string[];
  };
  customMessage: string;
  eventTime: string;
  eventType: string;
  application: string;
}

export interface Justification {
  id: string;
  issuerUserId: string;
  issuerEmail: string;
  request: JustificationRequest;
  eventId: string;
  creationTime: string; // ISODate
  updateTime: string; // ISODate
  statement: string;
  status: "Opened" | "Completed";
}

export type JustificationEventType =
  | "AnonymousLinkCreated"
  | "AnonymousLinkUpdated"
  | "CompanyLinkCreated"
  | "Email"
  | "FileSyncUploadedFull"
  | "FileUploaded"
  | "SecureLinkCreated"
  | "SecureLinkUpdated"
  | "SharingSet";

export interface JustificationQueryParams {
  issuer?: string;
  user?: string;
  severity?: string;
  timeFrom?: string;
  timeTo?: string;
  eventType?: string;
  application?: string;
  status?: "Opened" | "Completed";
}
